export function cutLinkFromPackDesc(desc: string): string
{
	return desc.slice(0, desc.indexOf("https://tribalbooks.io"));
}
